import Toastr from 'toastr2';

/**
 * Load toastr library and set default settings
 */
const toastr = new Toastr({
    newestOnTop: true,
    debug: false,
    showMethod: 'fadeIn',
    extendedTimeOut: 1000,
    onclick: null,
    rtl: true,
    showDuration: 300,
    timeOut: 5000,
    positionClass: 'toast-top-right',
    hideDuration: 1000,
    preventDuplicates: true,
    progressBar: true,
    closeButton: true,
    showEasing: 'swing',
    hideMethod: 'fadeOut'
});

export {toastr};